import SigliveServiceV2 from 'Service/sigliveServiceV2';

const getHostScheduleDetail = async (id) => {
  const { data } = await SigliveServiceV2({
    method: 'GET',
    url: `productivity-host/detail/${id}`,
  });

  return data?.data;
};

export default getHostScheduleDetail;
